/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import ExpiredDocCard from '../../../../common/components/ExpiredDocCard';
import { Box } from '@mui/system';
import CardForExpiredDocs from '../../../../common/components/CardForExpiredDocs/CardForExpiredDocs';
import _ from 'lodash';
import { Grid, Typography } from '@mui/material';
import emptyIcon from '../../../../assets/images/empty_icon.svg';

import { fonts, themes } from '../../../../common/themes/themes';
import Loader from '../../../../common/Lottifiers/Loader/Loader';
import Warning from '../../../../common/Modals/WarningModal/Warning';
import toast from 'react-hot-toast';

interface propsType {
  allDocsData: any;
  setDocsIdFordeletion: (id: number) => void;
  setEmpAttachedDoc: (id: number) => void;
  isLoading?: boolean;
  trans?: any;
  setDocsIdItemToBeUpdated: (id: number, is_expiry: number) => void;
  setExpiredNotficationDocsUpdated: (status: boolean) => void;
}

const ExpiredDocsPresenter: React.FC<propsType> = ({
  allDocsData,
  setDocsIdFordeletion,
  setEmpAttachedDoc,
  isLoading,
  trans,
  setDocsIdItemToBeUpdated,
  setExpiredNotficationDocsUpdated,
}) => {
  const [warningMessage, setWarningMessage] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState(false);
  const [docId, setDocId] = useState<number>(0);
  const [deleteId, setDeleteId] = useState<number>(0);
  const [isExpiry, setIsExpiry] = useState<number>(0);

  const handleDeleteWarning = (Docs: any) => {
    if (validateAction(Docs?.documen_type?.restrict_employee)) return;
    setDeleteMessage(true)
    setDeleteId(Docs.id)
  }

  const handleDeleteDocs = () => {
    setDocsIdFordeletion(deleteId);
    setDeleteMessage(false)
  };
  const handleViewNDownload = (id: number) => {
    setEmpAttachedDoc(id);
  };

  const handleExpiryNotification = (id: number, is_expiry: number) => {
    setWarningMessage(true);
    setDocId(id);
    setIsExpiry(is_expiry);
  };

  const handleExpiredNotificationStatus = (status: boolean) => {
    setExpiredNotficationDocsUpdated(status);
  };

  const warningresponse = (warningaction: any) => {
    if (warningaction) {
      setWarningMessage(false);
      setDocsIdItemToBeUpdated(docId, isExpiry);
      setDocId(0);
      setIsExpiry(0);
    }
  };

  const validateAction = (restrictEmployeeAction: number) => {
    if (restrictEmployeeAction === 1) {
      toast.error(trans('You are not allowed to perform this action'));
      return true;
    } else return false;
  }
  return (
    <>
      <Warning
        openmodal={warningMessage}
        oncancel={() => setWarningMessage(false)}
        title={trans('Are you sure? Are you going to take this action?')}
        infoMessage={trans('Please Confirm')}
        onconfirm={warningresponse}
      />
      <Warning
        openmodal={deleteMessage}
        oncancel={() => setDeleteMessage(false)}
        infoMessage={trans('Are You Deleting Expired Document?')}
        onconfirm={handleDeleteDocs}
      />
      <ExpiredDocCard
        card_title={trans('Expired Documents')}
        card_height="330px"
        card_subtitle={`${trans('Total')}: ${allDocsData ? allDocsData?.length : 0
          }`}
        trans={trans}
        checked={handleExpiredNotificationStatus}
      >
        <Box style={{ marginBottom: '24px' }} />
        {isLoading ? (
          <Loader height={100} width={200} />
        ) : (
          <div>
            {allDocsData?.length > 0 ? (
              _.map(allDocsData, (Docs: any) => {
                return (
                  <CardForExpiredDocs
                    key={Docs?.identifier_number}
                    tile_value={Docs?.documen_type?.type}
                    subtitle1={`${trans('Identifier No')}: `}
                    IdentifierNo={Docs?.identifier_number}
                    Issuetitle={trans('Issue')}
                    IssueDate={Docs?.issue_date}
                    Expirytitle={trans('Expired')}
                    ExpDate={Docs?.validity_date}
                    country={Docs?.issue_country}
                    isExpiryNotification={Docs?.is_expiry_notification}
                    onDelete={() => handleDeleteWarning(Docs)}
                    onView={() => handleViewNDownload(Docs.id)}
                    onExpiryNotification={() =>
                      handleExpiryNotification(Docs.id, 0)
                    }
                    onEnableExpiryNotification={() =>
                      handleExpiryNotification(Docs.id, 1)
                    }
                  />
                );
              })
            ) : (
              <Grid container>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <img src={emptyIcon} />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.title,
                      color: themes.blackDefault,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Not Added')}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.subtitle,
                      color: themes.defaultIcon,
                    }}
                  >
                    {trans('Currently you haven’t any Expired Documents')}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </div>
        )}
      </ExpiredDocCard>
    </>
  );
};
export default ExpiredDocsPresenter;
